<template>
  <YesNoRadio
    v-model="saarc.visited"
    :label="$tt('did_visit_saarc')"
    :hint="`${$tt('saarc_countries_are')}: ${SAARC_LIST.map(c => c.title).join(', ')}.`"
  />
  <v-expand-transition>
    <AppRow v-if="saarc.visited" class="mt-5">
      <AppMultiSelect
        v-model="saarc.countries"
        :label="$tt('which_countries_you_visited')"
        :items="SAARC_LIST"
        :rules="[required]"
      />
      <AppSelect v-model="saarc.year" :label="$tt('when_was_visit')" :items="YEARS" :rules="[required]" />
    </AppRow>
  </v-expand-transition>
</template>

<script setup lang="ts">
import { getCurrentYear } from '~/helpers/date';
import type { CountryIso, SaarcVisit } from '~/types';

const { required } = useValidation();
const { tCountry } = useLocalization();

const COUNTRIES: CountryIso[] = [
  'NPL', 'LKA', 'BGD', 'MDV', 'PAK', 'BTN', 'AFG'
];
const SAARC_LIST = COUNTRIES.map(iso => ({ value: iso, title: tCountry(iso) }));
const YEARS = new Array(4).fill(getCurrentYear()).map((y, i) => y - i);

const saarc = defineModel<SaarcVisit>({ required: true });
</script>